export default () => {
  const sliderParents = document.querySelectorAll('.js-swipe-slider-parent')

  if (sliderParents.length < 1) return
  if (document.body.clientWidth > 999) return
  ;[...sliderParents].forEach(sliderParent => {
    const slider = sliderParent.querySelector('.js-swipe-slider')
    const slides = sliderParent.querySelectorAll('.js-swipe-slide')
    const wrapper = sliderParent.querySelector('.js-swipe-slider-wrapper')
    const triggers = sliderParent.querySelectorAll('.js-swipe-slider-trigger')
    const next = sliderParent.querySelector('.js-thumbnail-slider-next') ? sliderParent.querySelector('.js-thumbnail-slider-next') : false
    const prev = sliderParent.querySelector('.js-thumbnail-slider-prev') ? sliderParent.querySelector('.js-thumbnail-slider-prev') : false
    const dots = sliderParent.querySelectorAll('.js-swipe-slider-dot')
    const thumbnailWrapper = sliderParent.querySelector('.js-swipe-slider-thumbnails')

    const positions = []
    const thumbnailPositions = []

    const slidesCount = sliderParent.querySelectorAll('.js-swipe-slide').length
    const firstSlide = sliderParent.querySelector('.js-swipe-slide')
    let slideWidth = firstSlide.offsetWidth + 16
    let sliderWidth = slider.offsetWidth
    let sliderScrollWidth = slider.scrollWidth

    let pos = 0
    let shown = sliderWidth

    if (!('IntersectionObserver' in window)) {
      return
    }

    if (slides.length < 1) return
    ;[...slides].forEach(slide => {
      positions.push(slide.getBoundingClientRect())
    })
    ;[...triggers].forEach(thumbnail => {
      thumbnailPositions.push(thumbnail.getBoundingClientRect())
    })
    ;[...triggers].forEach(trigger => {
      trigger.addEventListener('click', e => {
        const target = trigger.dataset.pos

        const position = positions[Number(target)]
        if (position) {
          wrapper.scrollTo({
            top: position.top,
            left: position.left,
            behavior: 'smooth'
          })
        }
      })
    })
    ;[...dots].forEach(dot => {
      dot.addEventListener('click', e => {
        const target = dot.dataset.pos

        const position = positions[Number(target)]
        if (position) {
          wrapper.scrollTo({
            top: position.top,
            left: position.left,
            behavior: 'smooth'
          })
        }
      })
    })

    const sliderObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const target = entry.target.dataset.pos
            const position = thumbnailPositions[Number(target)]

            if (position) {
              thumbnailWrapper.scrollTo({
                top: position.top,
                left: position.left - 16,
                behavior: 'smooth'
              })
            }

            ;[...triggers].forEach(trigger => {
              if (trigger.dataset.pos === entry.target.dataset.pos) {
                trigger.classList.add('active')
              } else {
                trigger.classList.remove('active')
              }
            })
            ;[...dots].forEach(dot => {
              if (dot.dataset.pos === entry.target.dataset.pos) {
                dot.classList.add('active')
              } else {
                dot.classList.remove('active')
              }
            })
          }
        })
      },
      { threshold: 0.8 }
    )

    ;[...slides].forEach(slide => {
      sliderObserver.observe(slide)
    })

    if (next && prev) {
      prev.addEventListener('click', () => {
        goPrev()
        navActivity()
      })
  
      next.addEventListener('click', () => {
        goNext()
        navActivity()
      })

      function setTransform() {
        slider.style['transform'] = 'translate3d(' + -pos * slideWidth + 'px,0,0)'
      }
  
      function goPrev() {
        if (pos > 0) {
          pos = Math.max(pos - 1, 0)
          setTransform()
          shown = shown - slideWidth
        }
      }
  
      function goNext() {
        if (shown < sliderScrollWidth) {
          pos = Math.min(pos + 1, slidesCount - 1)
          setTransform()
          shown = shown + slideWidth
        }
      }
  
      function navActivity() {
        if (pos > 0) {
          if (prev.classList.contains('inactive')) {
            prev.classList.remove('inactive')
          }
        } else {
          if (!prev.classList.contains('inactive')) {
            prev.classList.add('inactive')
          }
        }
  
        if (shown < sliderScrollWidth) {
          if (next.classList.contains('inactive')) {
            next.classList.remove('inactive')
          }
        } else {
          if (!next.classList.contains('inactive')) {
            next.classList.add('inactive')
          }
        }
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/ThumbnailSlider.js